import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Filter from '../Filter';
import SearchBar from '../SearchBar';
import Styles from './FindHeader.module.scss';

const { search_header: headlineText } = window.Language;

const FindHeader = ({
  fetchingSearch,
  filters,
  inputRef,
  isScrolled,
  onSearchClear,
  onSearchInputChange,
  searchValue,
  showBrowseTxt,
  Style,
}) => {
  const currentPath = window?.location?.pathname?.split('/')[1];

  return (
    <div className={classNames(Styles.findHeaderContainer, isScrolled && Styles.scrolled)}>
      <SearchBar
        isScrolled={isScrolled}
        onChange={onSearchInputChange}
        onClear={onSearchClear}
        theme={Style}
        value={searchValue}
        ref={inputRef}
        fetching={fetchingSearch}
      />
      {currentPath !== 'find' && (
        <div
          className={classNames(
            Styles.findBrowseTxtContainer,
            showBrowseTxt && Styles.findBrowseTxtContainerOpen,
          )}
        >
          <h1 className={Styles.findBrowseTxt}>{headlineText}</h1>
        </div>
      )}
      {searchValue && !fetchingSearch ? (
        <Filter
          isScrolled={isScrolled}
          tabs={filters}
          searchValue={searchValue}
          fetchingSearch={fetchingSearch}
        />
      ) : null}
    </div>
  );
};

FindHeader.propTypes = {
  fetchingSearch: PropTypes.bool,
  filters: PropTypes.arrayOf(PropTypes.shape({})),
  inputRef: PropTypes.shape({}),
  isScrolled: PropTypes.bool,
  onSearchClear: PropTypes.func,
  onSearchInputChange: PropTypes.func,
  searchValue: PropTypes.string,
  showBrowseTxt: PropTypes.bool,
  Style: PropTypes.shape({}),
};

export default FindHeader;
